import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/core/api.service';
import { UserService } from 'src/app/core/user.service';
import { ErrCode, SHARE_DETAILS_OPEN_STATE } from '../../models';


@Component({
  selector: 'app-verify-email-required',
  templateUrl: './verify-email-required.component.html',
  styleUrls: ['./verify-email-required.component.scss']
})
export class VerifyEmailRequiredComponent implements OnInit {
  @Input() public openState: number;
  @Input() public backState: number;
  @Input() showDialog!: boolean;
  @Output() openStateChange: EventEmitter<number> = new EventEmitter();
  @Input() cancelButtonText:'Close' | 'Back' = 'Back';
  @Input() message: string = 'Your account must be verified in order to invite new users to this shared folder.';

  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public errcode: ErrCode;
  public spinner: boolean;
  public success: boolean;
  public userEmail: string;
  description = '';
  constructor(
    private api: ApiService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.showDialog = true;
    this.success = false;
    this.spinner = false;
    this.errcode = undefined;
    this.userEmail = this.userService.get('email');
    this.description = `You should receive an email at ${this.userEmail} soon.`
  }
  public resendVerification = async () => {
    this.spinner = true;
    try {
      await this.api.execute('userverifyemailresend', {});
      this.success = true;
    } catch (ex) {
      this.errcode = ErrCode.fromException(ex);
    }
    this.spinner = false;
  }

  private openPopup(state: number) {
    this.openStateChange.next(state);
  }

  closeDialog = (state: number = SHARE_DETAILS_OPEN_STATE.CLOSE_STATE) => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(state>0 ? true : false);
      this.openPopup(state)
    }, 50);
  }
  onBack = () => {
    this.closeDialog(this.backState ?? SHARE_DETAILS_OPEN_STATE.MEMBER_LIST);
  }
  onSend = () => {
    this.resendVerification();
  }
}
